import { RUBBLE_SIGN } from '#shared/lib/constants';

export const TOTAL_QUANTITY_FILTER_ID = 'total_quantity';
export const TOTAL_QUANTITY_FILTER_TITLE = 'Остатки';

export const FINAL_PRICE_FILTER_ID = 'final_price';
export const FINAL_PRICE_FILTER_TITLE = 'Цена';

export const PRICE_FILTER_ID = 'price';
export const PRICE_FILTER_TITLE = 'Цена до скидки';

export const MANUAL_DISCOUNT_PRICE_FILTER_ID = 'manual_discount_price';
export const MANUAL_DISCOUNT_PRICE_FILTER_TITLE = 'Цена со скидкой';

export const PROMOTION_PRICE_FILTER_ID = 'promotion_price';
export const PROMOTION_PRICE_FILTER_TITLE = 'Цена по акции';

export const VAT_FILTER_ID = 'vat';
export const VAT_FILTER_TITLE = 'Ставка НДС';

export const PRODUCT_FILTER_BRAND_ID = 'brand';
export const BRAND_FILTER_TITLE = 'Бренд';

export const HAS_MEDIA_FILTER_ID = 'has-media';
export const HAS_MEDIA_FILTER_TITLE = 'Наличие изображения';

export const REQUIRES_MARKING_FILTER_ID = 'requires-marking';
export const REQUIRES_MARKING_FILTER_TITLE = 'Маркировка требуется';

export const PRODUCT_FILTER_BADGES_ID = 'badge_slugs';
export const BADGES_FILTER_TITLE = 'Бейджи';

export const PRODUCT_FILTER_COLLECTION_ID = 'collection';
export const PRODUCT_COLLECTION_FILTER_TITLE = 'Коллекция';

export const WAREHOUSES_FILTER_ID = 'warehouses';
export const WAREHOUSES_FILTER_TITLE = 'Склады';

export const SORT_WEIGHT_FILTER_ID = 'sort_weight';
export const SORT_WEIGHT_FILTER_TITLE = 'Приоритет в каталоге';

export const HAS_GROUPING_CHARS_ID = 'has-grouping';
export const HAS_GROUPING_CHARS_TITLE = 'Товар объединён в варианты';

export const WEIGHT_FILTER_ID = 'weight';
export const WEIGHT_FILTER_TITLE = 'Вес';

export const LENGTH_FILTER_ID = 'length';
export const LENGTH_FILTER_TITLE = 'Длина';

export const WIDTH_FILTER_ID = 'width';
export const WIDTH_FILTER_TITLE = 'Ширина';

export const HEIGHT_FILTER_ID = 'height';
export const HEIGHT_FILTER_TITLE = 'Высота';

export const PRICE_INDEX_COUNTS_FILTER_ID = 'price_index_counts';
export const PRICE_INDEX_COUNTS_FILTER_TITLE = 'Сравнение цен';

export const PRICE_INDEX_PERCENT_FILTER_ID = 'price_index_percent';
export const PRICE_INDEX_PERCENT_FILTER_TITLE = 'Разница цены с другой площадкой (%)';

export const PRICE_INDEX_DIFFERENCE_FILTER_ID = 'price_index_diff_size';
export const PRICE_INDEX_DIFFERENCE_FILTER_TITLE = `Разница цены с другой площадкой (${RUBBLE_SIGN})`;

export const PRICE_INDEX_CHEAPEST_MARKETPLACE_FILTER_ID = 'price_index_cheapest_marketplace';
export const PRICE_INDEX_CHEAPEST_MARKETPLACE_FILTER_TITLE = 'Площадка с минимальной ценой';

export const HAS_MINIMAL_PRICE_FILTER_ID = 'minimal_price';
export const HAS_MINIMAL_PRICE_FILTER_TITLE = 'Минимальная цена';

export const HAS_FEEDBACK_SOURCE_FILTER_ID = 'has_feedback_source';
export const HAS_FEEDBACK_SOURCE_FILTER_TITLE = 'Отзывы';

export const PRODUCT_FILTER_SEARCH_PARAM_KEYS = {
    search: 'search',
    statuses: 'statuses',
    moderationStatus: 'moderation_status',
    categories: 'categories',
    collections: 'collections',
    filter: 'filter',
} as const;
